import { dynamicImport, isPresent as isComponentPresent } from "components-utils";

const BhgComponent = ({ selector, path, initMethod = "init", skipInit = false, belongsTo = "", customName = "", forceImport = false }) => ({
  forceImport,

  isPresent: () => forceImport || isComponentPresent(selector),

  importComponent: async ({ name, root }) => {
    const component = await import(`./${path}.js`);
    return dynamicImport({
      name,
      customName,
      belongsTo,
      component,
      initMethod,
      skipInit,
      root,
    });
  },

  componentClass: () => ({
    selector,
  }),
});

const components = {
  genericText: BhgComponent({ selector: ".cmp-text", path: "genericText" }),
  assetVideo: BhgComponent({ selector: ".c-video,.gallery,.c-carousel,.brh-video", path: "asset-video" }),
};

export default components;
